export const MESSAGES = {
    LOADING: '読み込み中...',
    LOAD_FAILED: '読み込みに失敗しました',
    LOGIN_FAILED: 'ログインに失敗しました',
};
